import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PaginationState {
  page: number;
  rowsPerPage: any;
}

const initialState: PaginationState = {
  page: 0,
  rowsPerPage: 50,
};

const StaffMemberUseCasePaginationSlice = createSlice({
  name: 'StaffMemberUseCasePagination',
  initialState,
  reducers: {
    setPageData: (state, action: PayloadAction<number>) => {
      state.page = action.payload;
    },
    setRowsPerPageData: (state, action: PayloadAction<any>) => {
      state.rowsPerPage = action.payload;
    },
    resetPagination: (state) => {
      state.page = 0;
      state.rowsPerPage = 50;
    },
  },
});

export const { setPageData, setRowsPerPageData, resetPagination } = StaffMemberUseCasePaginationSlice.actions;
export default StaffMemberUseCasePaginationSlice.reducer;